// permissions.ts
export const PERMISSIONS = {
  SYSTEM_MANAGEMENT: { READ:  0o100000, WRITE: 0o200000 },
  DATASET_MANAGEMENT:{ READ:  0o010000, WRITE: 0o020000 },
  MODEL_MANAGEMENT:  { READ:  0o001000, WRITE: 0o002000 },
  TEACHMODE:         { READ:  0o000100, WRITE: 0o000200 },
  IMAGE_VIEW:        { READ:  0o000010, WRITE: 0o000020 },
  DASHBOARD:         { READ:  0o000001, WRITE: 0o000002 },
  ROLE_MANAGEMENT:   { READ:  0o400000, WRITE: 0o1000000 },
  MATRIX_MAPPING:    { READ: 0o2000000, WRITE: 0o4000000 },
} as const;
